// IndexDisplay.js
export default function (routePath, APP_NAME) {
  return ((routePath !== '/' && routePath !== '/disconnect' && routePath !== '/app/confirmation') && APP_NAME === 'commercant')
}



// WEBPACK FOOTER //
// ./src/common/lib/IndexDisplay.js